export default {"src":"/_next/static/media/kaiwaLogo.376719ec.svg","height":159,"width":184,"blurWidth":0,"blurHeight":0};